<div class="mx-auto md:w-2/3 w-full">
  <% if @person.studio %>
  <h1 class="font-bold text-4xl">New Participant/Guest</h1>
  <% else %>
  <h1 class="font-bold text-4xl">New Event Staff Member</h1>
  <% end %>

  <%= render "form", person: @person %>

  <div class="mx-auto flex">
    <input type="submit" class="rounded-lg py-3 px-5 bg-blue-600 text-white inline-block font-medium cursor-pointer" form="person-form" value="Create Person">
    <%= link_to "Back to people", people_path, class: "ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium" %>
  </div>
</div>
